import { type ReactNode, createContext, useCallback, useContext, useState } from 'react'

interface SidebarContextValue {
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  closeSidebar: () => void
}

const SidebarContext = createContext<SidebarContextValue | null>(null)

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true)

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev)
  }, [])

  const closeSidebar = useCallback(() => {
    setSidebarCollapsed(true)
  }, [])

  return (
    <SidebarContext.Provider value={{ sidebarCollapsed, toggleSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
